<!--
 * @Description: 
 * @Date: 2019-08-02 15:05:16
 -->

<template>
  <div class="table-box">
    <!-- <div class="hidden-detail" @click="close">
      <i class="el-icon-close"></i>
    </div>-->
    <el-button
      @click="close"
      type="text"
      class="newBackBtn"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="clearfix"></div>
    <!--列表-->
    <div style="min-height: 60vh">
      <el-table
        :data="data.taskList"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in data.titleList[0]"
          :key="index"
          :show-overflow-tooltip="true"
          align="center"
          :label="item"
        >
          <template slot-scope="{ row }">
            <span>{{ row[index] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tableDetail',
  props: {
    data: {
      default: {
        taskList: [],
        titleList: [],
        tableData: []
      }
    }
  },
  data() {
    return {
      prop: {
        label: 'projectName',
        code: 'id'
      },
      // searchAjax: project.crmProjectList,
      extraObj: {
        type: 1
      }
    };
  },
  components: {
    // dicSelect
  },
  computed: {
    //     ...mapState({
    //         projectType: state => state.homeProject.projectType,
    //         projectId: state => state.homeProject.id
    //     })
  },
  methods: {
    close() {
      this.$router.back();
      // this.$parent.hideDetail()
    },
    dateChange(val) {},
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },
    // exportEvent() {
    //     let {projectId, month, userId} = this.$route.query;
    //     if (this.projectId && month && userId) {
    //         let queryString = this.$querystring.stringify({
    //             projectId,
    //             taskMonth: month,
    //             userId
    //         });
    //         window.open(exportUserHgtgExcel + "?" + queryString);
    //     } else {
    //         this.$message.error("请选择条件");
    //     }
    // },
    // saveEnterpriseId(val) {
    //     //保存
    //     this.searchQuery.enterpriseId = val.id;
    // },
    // add() {
    //     this.$router.push({
    //         name: "salerAdd"
    //     });
    // },
    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        visit
          .pass({
            id: row.id,
            status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },
  filters: {
    transAuditStatus(val) {
      if (val == 1) {
        return '审核中';
      } else if (val == 2) {
        return '审核通过';
      } else if (val == 3) {
        return '审核未通过';
      }
    }
  },
  created() {
    // selectMonthTask(this.$route.query).then(res => {
    //     let {taskList, titleList} = res.data.data;
    //     this.taskList = taskList;
    //     this.titleList = titleList;
    // });
  }
};
</script>
<style lang="scss" scoped>
.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
}
</style>
